/* ============================================================================
   Strum: buy-box submits open the cart drawer instead of navigating (Grüns
   pattern, 4 Aug 2026). The buy box is a plain POST form to /cart/add —
   correct with JS off, and this file leaves that path as the fallback. With
   JS on and a drawer on the page: intercept, add via /cart/add.js, re-render
   the header section through the Section Rendering API, swap in the fresh
   <cart-drawer-component> (its connectedCallback rewires refs), and open it.
   ========================================================================= */
(function () {
  'use strict';

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-buy-form]');
    if (!form) return;

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return; // no drawer on this page — native flow

    event.preventDefault();

    var button = form.querySelector('[data-add-to-cart]');
    if (button) button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return refreshAndOpen();
      })
      .catch(function () {
        // Add genuinely failed (sold out, etc.) — let Shopify's native page
        // present the error. Nothing was added, so no double-add risk.
        form.removeAttribute('data-buy-form');
        form.submit();
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }, true);

  // Empty-state "Continue shopping": inside the drawer it's a dismissal, not
  // a navigation — close and leave the shopper where they were. The same
  // snippet renders on the cart page with no drawer ancestor; there the link
  // navigates as stock Horizon intends.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-items__empty-button');
    if (!button) return;
    var drawer = button.closest('cart-drawer-component');
    if (!drawer) return;

    event.preventDefault();
    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      var dialog = drawer.querySelector('dialog');
      if (dialog && dialog.open) dialog.close();
    }
  }, true);

  function refreshAndOpen() {
    var drawer = document.querySelector('cart-drawer-component');
    var host = drawer && drawer.closest('.shopify-section');
    if (!host) {
      window.location.href = '/cart';
      return;
    }
    var sectionId = host.id.replace('shopify-section-', '');
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (payload) {
        var holder = document.createElement('div');
        holder.innerHTML = payload[sectionId] || '';
        var fresh = holder.querySelector('cart-drawer-component');
        if (!fresh) {
          window.location.href = '/cart';
          return;
        }
        drawer.replaceWith(fresh);
        // Counts outside the drawer (e.g. sticky bar) follow the fresh pill.
        var freshCount = fresh.querySelector('[data-cart-count]');
        if (freshCount) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = freshCount.textContent;
            el.classList.toggle('is-empty', freshCount.classList.contains('is-empty'));
          });
        }
        requestAnimationFrame(function () {
          if (typeof fresh.open === 'function') {
            fresh.open();
          } else {
            var dialog = fresh.querySelector('dialog');
            if (dialog && !dialog.open) dialog.showModal();
          }
        });
      })
      .catch(function () {
        // Item IS in the cart; worst case we fall back to the cart page.
        window.location.href = '/cart';
      });
  }
})();
